(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pg-booking"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-booking')) {
  customElements.define('pg-booking', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const success = this.querySelector('.pg-form-success');
      if (success) { success.focus(); return; }
      if (!form) return;
      const text = JSON.parse(this.querySelector('[data-booking-copy]').textContent);
      const steps = [...this.querySelectorAll('[data-step]')];
      const progress = this.querySelector('.pg-booking-progress');
      const back = this.querySelector('[data-back]');
      const next = this.querySelector('[data-next]');
      const send = this.querySelector('[data-send]');
      const error = this.querySelector('.pg-booking-error');
      const controls = this.querySelector('.pg-booking-controls');
      const durationInputs = [...form.querySelectorAll('[name="contact[duration]"]')];
      const priceMap = {1: 499, 2: 899, 4: 1999, 8: 3499};
      const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:'USD', maximumFractionDigits:0}).format(n) + ' USD';
      const field = name => form.elements.namedItem(name);
      const value = name => (field(name)?.value || '').trim();
      const custom = () => value('contact[service]') === 'custom';
      const sequence = () => custom() ? [0,1,3,4] : [0,1,2,3,4];
      let current = 0;
      let reviewed = false;
      let sending = false;
      const today = new Date();
      const todayString = [today.getFullYear(), String(today.getMonth()+1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-');
      field('contact[preferred_date]').min = todayString;
      form.noValidate = true;
      const params = new URLSearchParams(location.search);
      const preService = params.get('service') === 'custom' ? 'custom' : params.get('need');
      const serviceInput = [...form.querySelectorAll('[name="contact[service]"]')].find(i => i.value === preService);
      if (serviceInput) serviceInput.checked = true;
      const durationInput = durationInputs.find(i => i.value === params.get('duration'));
      if (durationInput) durationInput.checked = true;
      const getEstimate = () => custom() ? text.customStarting : money(priceMap[value('contact[duration]')]);
      const fillEstimate = () => {
        if (!custom() && !Object.hasOwn(priceMap,value('contact[duration]'))) return false;
        const estimate = getEstimate();
        this.querySelector('[data-estimate-price]').textContent = custom() ? '$10,000+ USD' : estimate;
        this.querySelector('[data-estimate-label]').textContent = custom() ? text.custom : text.estimate;
        this.querySelector('[data-estimate-duration]').textContent = custom() ? text.customStarting : text.durations[value('contact[duration]')];
        this.querySelectorAll('[data-standard-only]').forEach(n => n.hidden = custom());
        this.querySelectorAll('[data-custom-only]').forEach(n => n.hidden = !custom());
        this.querySelector('[data-summary-brief]').textContent = value('contact[body]');
        this.querySelector('[data-summary-location]').textContent = [value('contact[city_and_region]'),value('contact[postal_code]'),value('contact[location]')].filter(Boolean).join(' · ');
        this.querySelector('[data-recap]').textContent = custom() ? text.customStarting + ' · ' + text.pending : text.durations[value('contact[duration]')] + ' · ' + estimate + ' · ' + text.sameDay;
        this.querySelector('[data-estimate-input]').value = custom() ? 'Custom production: most projects begin at $10,000 USD; consultation required for final quote.' : text.durations[value('contact[duration]')] + ': ' + estimate + '; on-site production and same-day edits. Final scope, travel and taxes confirmed before booking.';
        this.querySelector('[data-request-type]').value = custom() ? 'Custom production consultation request' : 'Content service appointment request';
        send.textContent = custom() ? text.consult : text.request;
        return true;
      };
      const show = (n, focus=true) => {
        current=n;
        error.hidden=true;
        durationInputs.forEach(i=>i.disabled=custom());
        steps.forEach((s,i) => s.hidden=i!==n);
        const order=sequence();
        this.querySelector('[data-step-count]').textContent=text.step.replace('{current}',order.indexOf(n)+1).replace('{total}',order.length);
        this.querySelectorAll('[data-marker]').forEach(m=>{
          const index=Number(m.dataset.marker);
          m.hidden=!order.includes(index);
          m.toggleAttribute('data-complete',order.indexOf(index)<order.indexOf(n));
          if(index===n)m.setAttribute('aria-current','step');else m.removeAttribute('aria-current');
        });
        back.hidden=n===0;
        next.hidden=n===4;
        send.hidden=n!==4;
        next.textContent=n===3?text.date:(n===2 || (n===1 && custom()))?text.review:text.continue;
        if(n>=3)fillEstimate();
        if(focus){ steps[n].querySelector('legend').focus(); this.scrollIntoView({behavior:'instant',block:'start'}); }
      };
      const invalidField = s => [...s.querySelectorAll('input,select,textarea')].find(i=>!i.disabled && !i.checkValidity());
      const validate = n => {
        const date=field('contact[preferred_date]');
        date.setCustomValidity(date.value && date.value<todayString ? text.past : '');
        const bad=invalidField(steps[n]);
        if(!bad)return true;
        error.textContent=text.invalid;
        error.hidden=false;
        bad.focus();bad.reportValidity();return false;
      };
      const advance = () => {
        if(!validate(current))return;
        if(current===3) reviewed=true;
        const order=sequence();
        const n=order[order.indexOf(current)+1];
        if(n!==undefined)show(n);
      };
      next.addEventListener('click',advance);
      back.addEventListener('click',()=>{const order=sequence();show(order[order.indexOf(current)-1] || 0);});
      form.addEventListener('change',e=>{
        if(e.target.closest('[data-step="0"],[data-step="1"],[data-step="2"]'))reviewed=false;
        if(e.target.name==='contact[service]')durationInputs.forEach(i=>i.disabled=custom());
      });
      form.addEventListener('submit',e=>{
        if(sending){e.preventDefault();return;}
        if(current!==4){e.preventDefault();advance();return;}
        for(const n of sequence()){
          if(invalidField(steps[n])){e.preventDefault();show(n);validate(n);return;}
        }
        if(!reviewed){e.preventDefault();show(3);return;}
        if(!validate(4) || !fillEstimate()){e.preventDefault();return;}
        sending=true;send.disabled=true;send.textContent=text.sending;
        window.setTimeout(()=>{sending=false;send.disabled=false;send.textContent=custom()?text.consult:text.request;},15000);
      });
      window.addEventListener('pageshow',()=>{sending=false;send.disabled=false;send.textContent=custom()?text.consult:text.request;});
      progress.hidden=false;controls.hidden=false;show(0,false);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
